/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskOverviewUser = {
  /**
   * User email, or Unknown user when unavailable.
   */
  email: string;
  /**
   * External user identifier as recorded on chats, when known. Empty when the finding cannot be attributed to an external user.
   */
  externalUserId: string;
  /**
   * Finding count for this user.
   */
  findings: number;
};

/** @internal */
export const RiskOverviewUser$inboundSchema: z.ZodMiniType<
  RiskOverviewUser,
  unknown
> = z.pipe(
  z.object({
    email: z.string(),
    external_user_id: z.string(),
    findings: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "external_user_id": "externalUserId",
    });
  }),
);

export function riskOverviewUserFromJSON(
  jsonString: string,
): SafeParseResult<RiskOverviewUser, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskOverviewUser$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskOverviewUser' from JSON`,
  );
}
